import React from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import AllAcountsSection from "../../Components/AllAccountsSection/AllAcountsSection";

import ContainsArea from "../../Components/ContainsArea/ContainsArea";

import { useEffect } from "react";
import bgimg from "../../assets/images/IZB/IZB Website Skin/IZB Save Plus Account/image_6.png";
import VideoSliderUpdated from "../../Components/VideoSlider/VideoSliderUpdated";


const NetBanking = () => {
  const moneyTransfer = "https://izbassetsmain.blob.core.windows.net/izbwebassets/netbanking-money-transfer.png";
const ZambiaRevenue = "https://izbassetsmain.blob.core.windows.net/izbwebassets/download.jpeg";
const napsa = "https://izbassetsmain.blob.core.windows.net/izbwebassets/NAPSA-logo-2018.png";
const nihma = "https://izbassetsmain.blob.core.windows.net/izbwebassets/nhima_logo_02.jpg";
const bill = "https://izbassetsmain.blob.core.windows.net/izbwebassets/bill.png";
const mobileApp = "https://izbassetsmain.blob.core.windows.net/izbwebassets/mobile-app.png";
const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/netbanking-bank-statement.png";
const onlineBanking = "https://izbassetsmain.blob.core.windows.net/izbwebassets/online-banking 1.png";
const stockMarket = "https://izbassetsmain.blob.core.windows.net/izbwebassets/stock-market.png";
const CC = "https://izbassetsmain.blob.core.windows.net/izbwebassets/netbanking-creditcard.png";
const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-mobile-banking-banner.png";
const img = "https://izbassetsmain.blob.core.windows.net/izbwebassets/net-banking-single-page.png";

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const content =
    "Manage your account conveniently through the Internet. Up-to-the-second details of your account Access anytime, from anywhere No queues to stand in, or turns to wait for.View Account Balances Monitor cleared transactions, forex rates inquiry vew, print and store electronic copies of your statements";


  const videoData = [
      { id: 1, videoSrc: 'https://www.youtube.com/embed/bsVfy9wxEYc' },
      { id: 2, videoSrc: 'https://www.youtube.com/embed/ToH-3P7cdMc' },
      { id: 3, videoSrc: 'https://www.youtube.com/embed/F3ViA2_XB1s' },
      { id: 4, videoSrc: 'https://www.youtube.com/embed/ZF2XUI9rnbA' },
      { id: 5, videoSrc: 'https://www.youtube.com/embed/Jl4cNeb_Zv8' },
      { id: 6, videoSrc: 'https://www.youtube.com/embed/sJfK4_BhGdc' },
      { id: 7, videoSrc: 'https://www.youtube.com/embed/o7lUF9V3jW0' },
      { id: 8, videoSrc: 'https://www.youtube.com/embed/lRYuCacIsOQ' },
      { id: 9, videoSrc: 'https://www.youtube.com/embed/aPwb4CJzJbY' },
      { id: 10, videoSrc: 'https://www.youtube.com/embed/X0MgVpLkl1s' },
      { id: 11, videoSrc: 'https://www.youtube.com/embed/V4qoz-puPzI' },
      { id: 12, videoSrc: 'https://www.youtube.com/embed/R_AeXEi7C9E' },
      { id: 13, videoSrc: 'https://www.youtube.com/embed/Txi6ien5VfY' },
      { id: 14, videoSrc: 'https://www.youtube.com/embed/EymFcARx1Rc' },
      { id: 15, videoSrc: 'https://www.youtube.com/embed/MwDz9vdR71E' },
      { id: 16, videoSrc: 'https://www.youtube.com/embed/A6WqURQyBGs' },
      { id: 17, videoSrc: 'https://www.youtube.com/embed/u8SUf5_i7ZI' },
      { id: 18, videoSrc: 'https://www.youtube.com/embed/BlmMEKEz0b0' },
      { id: 19, videoSrc: 'https://www.youtube.com/embed/yOO0v1j7sTU' },
      { id: 20, videoSrc: 'https://www.youtube.com/embed/Hnq8eO5rIOI' },
  ];

  return (
    <>
      <Breadcrumb Heading="Indo Net Banking" img={BackgroundBrundcrumb} />
      <section className="overview-area">
        <div className="container">
          <div className="row">
            <div className="col-md-5 col-xl-5">
              <div className="overview-content-box-one">
                <img src={img} width="100%" alt="" />
              </div>
            </div>
            <div className="col-xl-6 col-md-6 ">
              <div className="overview-content-box-two h-100 d-flex flex-column justify-content-center">
                <div className="inner-title">
                  <h5>Know About</h5>
                  <h2>Indo Net Banking</h2>
                </div>
                <div className="text">
                  <p>{content}</p>
                </div>
                <div className="d-flex gap-2" style={{justifyContent:"flex-start",marginBottom:"7vw"}}>
                  <button
                    className="btn btn-danger text-white fs-5"
                    style={{ backgroundColor: "#9E1B1E",width:"30%" }}
                  >
                    <a className="text-white" href="https://netbanking.izb.co.zm/ReachInet/IZB-web/inet/index.html" target="_blank">

                    Retail / Corporate
                    </a>
                  </button>
                  {/* <button
                    className="btn btn-danger  text-white fs-5"
                    style={{ backgroundColor: "#9E1B1E",width:"30%" }}
                  >
                    <a className="text-white" href="https://ebanking.izb.co.zm:7004/CorporateBanking/#/landing">

                    Corporate
                    </a>
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ContainsArea />

      <section
        id="benefits"
        class="benefits-style2-area"
        className="choose-style1-area"
      >
        <div className="container pt-4">
          <div className="text-center my-5">
            <h1 style={{ color: "#484848" }}>INDO Net Banking Benefits</h1>
            <p style={{ color: "#484848", paddingTop: "8px" }}>
              We help Businesses and customers achieve more.
            </p>
          </div>
          <div className="privilege-current-account-benefits">
            <ul className="choose-style1__content flex-wrap justify-content-start">
              <li className="single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={moneyTransfer} alt="" />
                  </div>
                  <div className="text">
                    <h5>Money Transfers</h5>
                  </div>
                </div>
              </li>
              <li className="single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={ZambiaRevenue} alt="" />
                  </div>
                  <div className="text">
                    <h5>Online tax payments to ZRA</h5>
                  </div>
                </div>
              </li>
              <li className="single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={napsa} alt="" />
                  </div>
                  <div className="text">
                    <h5>Online payments for NAPSA</h5>
                  </div>
                </div>
              </li>
              <li className="single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={nihma} alt="" />
                  </div>
                  <div className="text">
                    <h5>Online payments for NHIMA</h5>
                  </div>
                </div>
              </li>
              <li className="single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={bill} alt="" />
                  </div>
                  <div className="text">
                    <h5>Bill payments</h5>
                  </div>
                </div>
              </li>
              <li className="single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={mobileApp} alt="" />
                  </div>
                  <div className="text">
                    <h5>Mobile recharge</h5>
                  </div>
                </div>
              </li>
              <li className="single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={onlineBanking} alt="" />
                  </div>
                  <div className="text">
                    <h5>Bank to Wallet transfer</h5>
                  </div>
                </div>
              </li>
              <li className="single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={stockMarket} alt="" />
                  </div>
                  <div className="text">
                    <h5>Purchase forex</h5>
                  </div>
                </div>
              </li>
              <li className="single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={CC} alt="" />
                  </div>
                  <div className="text">
                    <h5>Block debit card and much more...</h5>
                  </div>
                </div>
              </li>
              <li className="single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={img1} alt="" />
                  </div>
                  <div className="text">
                    <h5>Account Monitoring & statement requests</h5>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section
        id="eligibility"
        class="eligibility-area how-to-sign-up-for-netbanking"
        style={{ backgroundColor: "#FFF5E7" }}
      >
        <div className="container-fluid">
          <div className="sec-title text-center">
            <h2>How to Sign Up for Net Banking</h2>
         
          </div>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-11 col-lg-11">
            
                <div
                  className="single-documents-box h-100"
                  style={{ backgroundColor: "#9E1B1E" }}
                >
                  <ul>
                    <li>
                      <div className="inner-title">
                        <p className="text-white">
                          Open below link in your web browser<br/>
                          <a href="https://ebanking.izb.co.zm:7004/Retail/#/landing">
                           <span style={{fontSize:"11px!important",color:"white" }}>https://ebanking.izb.co.zm:7004/Retail/#/landing</span></a>
                      
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="inner-title">
                        <p className="text-white">
                          Click on the sign up tab and enter the required
                          details in the fields provided
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="inner-title">
                        <p className="text-white">
                          Accept the terms and conditions and Click the submit
                          button
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="inner-title">
                        <p className="text-white">
                          Setup your Desired USERNAME, and Password in the
                          second screen and submit
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="inner-title">
                        <p className="text-white">
                          After setting up your USERNAME and Password an
                          activation link will be sent to your registered mobile
                          number and email. Open the activation link to activate
                          your account and login to transact.
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
            
              </div>
            </div>
          </div>
        </div>
      </section>
{/* 
      <section
      id="required"
      class="documents-area"
      style={{
        backgroundImage: `url(${bgimg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <div className="container">
        <div className="text-center">
          <h1 className="text-white">
           IZB Net Banking Service Charges
          </h1>
          <p className="text-white">
            Your money is making money for you & Your Family.
          </p>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="job-list-table-box">
              <div className="table-outer">
              <table className="job-list-table">
                  <thead className="header ">
                    <tr>
                      <th>SL. No</th>
                      <th>Service</th>
                      <th>Service Charge</th>
                    </tr>
                  </thead>
                  <tbody className="text-white">
                    <tr>
                      <td className="department text-white">
                        <h3>1.</h3>
                      </td>
                      <td className="location">
                        <p>Balance inquiry</p>
                      </td>
                      <td className="location">
                        <p>
                        Free
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td className="department text-white">
                        <h3>2.</h3>
                      </td>
                      <td className="location">
                        <p>Maintenance</p>
                      </td>
                      <td className="location">
                        <p>Retail → Free • Corporate → K120/-p.ad</p>
                      </td>
                    </tr>
                    <tr>
                      <td className="department">
                        <h3>3.</h3>
                      </td>
                      <td className="location">
                        <p>Password Reset</p>
                      </td>
                      <td className="location">
                        <p>Electronic → Free • Manual → K25/- per reset</p>
                      </td>
                    </tr>
                    <tr>
                      <td className="department">
                        <h3>4.</h3>
                      </td>
                      <td className="location">
                        <p>Bill Payment</p>
                      </td>
                      <td className="location">
                        <p>Free</p>
                      </td>
                    </tr>
                    <tr>
                      <td className="department">
                        <h3>5.</h3>
                      </td>
                      <td className="location">
                        <p>Mini-statement</p>
                      </td>
                      <td className="location">
                        <p>Free</p>
                      </td>
                    </tr>
                    <tr>
                      <td className="department">
                        <h3>6.</h3>
                      </td>
                      <td className="location">
                        <p>Internal Transfer</p>
                      </td>
                      <td className="location">
                        <p>Free</p>
                      </td>
                    </tr>
                    <tr>
                      <td className="department">
                        <h3>7.</h3>
                      </td>
                      <td className="location">
                        <p>DDACC</p>
                      </td>
                      <td className="location">
                        <p>K10/- per transaction</p>
                      </td>
                    </tr>
                    <tr>
                      <td className="department">
                        <h3>8.</h3>
                      </td>
                      <td className="location">
                        <p>RTGS</p>
                      </td>
                      <td className="location">
                        <p>K40/- per transaction</p>
                      </td>
                    </tr>
                    <tr>
                      <td className="department">
                        <h3>9.</h3>
                      </td>
                      <td className="location">
                        <p>Outward Telegraphic Transfer</p>
                      </td>
                      <td className="location">
                        <p>0.6%, (Min USD40/- Max. USD75/-)  <br />
                           USD20/- for INR</p>
                      </td>
                    </tr>
                    <tr>
                      <td className="department">
                        <h3>10.</h3>
                      </td>
                      <td className="location">
                        <p>Mobile Transfer (MNO/NFS)</p>
                      </td>
                      <td className="location">
                        <p>K150/- & below → K5/- per transaction  <br />
                           Above K150/- → K10/- per transaction</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> */}


      <VideoSliderUpdated heading="Unlock Seamless Banking Convenience" subheading="Explore Our Indo Net Banking Tutorial Videos" videoData={videoData} />
      
      <section className="indo-net-banking-page">
        <AllAcountsSection />
      </section>
    </>
  );
};

export default NetBanking;
